import React, { Component } from "react";
import { connect } from "react-redux";
import { Tabs, Alert, Card, Divider,Tag } from "antd";
import {
  req_single_cms_school_student,
  req_single_cms_learnmap_yearplan,
  req_single_cms_learnmap_talent_tab,
  req_single_cms_learnmap_talent_certificate_map,
  req_single_cms_learnmap_talent_certificate_course,
  req_single_cms_learnmap_talent_certificate_occupation,
  req_single_cms_learnmap_talent_occupation_course,
  req_single_cms_learnmap_talent_occupation_certificate,
} from "../../api";
import "./coursemap-student-course-licensemap.css";

const { TabPane } = Tabs;
class CoursemapStudentCourseLicensemap extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    items: [],
    deviceWidth: 0,
    loading: false,
    detailsloading: false,
    defaultKey: null,
    talents: [],
    courses: [],
    selectedCourses: [],
    occupations: [],
    selectedOccupations: [],
    occupation: null,
    certificates: [],
    selectedCertificates: [],
    certificate: null,
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_init_items();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_init_items = async () => {
    const { userCode, token } = this.props.user;
    this.setState({ loading: true, items: [] });
    const result = await req_single_cms_school_student(userCode, token);
    if (result) {
      const yearplan = await req_single_cms_learnmap_yearplan(result, token);
      if (yearplan) {
        const tab = await req_single_cms_learnmap_talent_tab(userCode, token);
        if (tab) {
          if (tab.total > 0) {
            const talents = tab.data;
            const defaultKey = talents[0].nidTalent;
            this.setState({ talents, defaultKey });
            this.tab_change(defaultKey);
            this.setState({ loading: false });
          }
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  };

  // 介面互動處理 //////////////////////////////////////////////
  tab_change = async (key) => {
    const { talents } = this.state;
    const { token } = this.props.user;
    const talent = talents.find((x) => x.nidTalent === key);
    //console.log('talent', talent)
    const tagret = {
      gidLearnMapMeta: talent.gidLearnMapMeta,
      nidLearnMapMeta: talent.nidLearnMapMeta,
      gidTalent: talent.gidTalent,
      nidTalent: talent.nidTalent,
    };
    this.setState({
      certificates: [],
      courses: [],
      occupations: [],
      detailsloading: true,
    });
    const result = await req_single_cms_learnmap_talent_certificate_map(
      tagret,
      token
    );
    if (result) {
      if (result.total > 0) {
        const rows = result.data;
        const certificates = rows[0].certificateItems;
        const courses = rows[0].courseMapItems;
        const occupations = rows[0].occupationItems;
        this.setState({ certificates, courses, occupations });
        //console.log('items', items)
        //console.log('items_courses', courses)
        //console.log('items_occupations', occupations)
      }
    }
    this.setState({ loading: false, detailsloading: false });
  };

  handle_certificate_click = async (item) => {
    console.log(item);
    const { token } = this.props.user;
    const { certificateTwName, gidTalentExamCertificate } = item;

    this.setState({
      selectedCourses: [],
      selectedOccupations: [],
      selectedCertificates: [],
      certificate: null,
      detailsloading: true,
    });
    // 選定[證照]對應[課程]
    const remote_course =
      await req_single_cms_learnmap_talent_certificate_course(item, token);
    if (remote_course) {
      if (remote_course.total > 0) {
        const { courses } = this.state;
        const selectedCourses = remote_course.data;
        courses.forEach((item) => {
          item.isLocked = "N";
        });
        for (let i = 0; i < selectedCourses.length; i++) {
          let course = selectedCourses[i];
          let code = course.courseCode;
          courses.forEach((item) => {
            if (item.courseCode === code) {
              item.isLocked = "Y";
            }
          });
        }
        this.setState({ courses, selectedCourses });
        //console.log('courses', courses)
      }
    }
    //清除[職業]選定，指定用戶所選
    const { certificates } = this.state;
    certificates.forEach((item) => {
      if (item.gidTalentExamCertificate === gidTalentExamCertificate) {
        item.isLocked = "Y";
      } else {
        item.isLocked = "N";
      }
    });
    this.setState({ certificates });
    // 選定[證照]對應[職業]
    const remote_occupation =
      await req_single_cms_learnmap_talent_certificate_occupation(item, token);
    if (remote_occupation) {
      if (remote_occupation.total > 0) {
        const selectedOccupations = remote_occupation.data;
        const { occupations } = this.state;
        occupations.forEach((item) => {
          item.isLocked = "N";
        });
        for (let i = 0; i < selectedOccupations.length; i++) {
          let occupation = selectedOccupations[i];
          let code = occupation.gidTalentOccupation;
          occupations.forEach((item) => {
            if (item.gidTalentOccupation === code) {
              item.isLocked = "Y";
            }
          });
        }
        this.setState({ occupations, selectedOccupations });
        //console.log('occupations', selectedOccupations)
      }
    }
    this.setState({ certificate: certificateTwName, detailsloading: false });
  };

  handle_occupation_click = async (item) => {
    console.log(item);
    const { token } = this.props.user;
    const { jobName, gidTalentOccupation } = item;

    this.setState({
      selectedCourses: [],
      selectedOccupations: [],
      selectedCertificates: [],
      occupation: null,
      detailsloading: true,
    });
    // 選定[職業]對應[課程]
    const remote_course =
      await req_single_cms_learnmap_talent_occupation_course(item, token);
    if (remote_course) {
      if (remote_course.total > 0) {
        const { courses } = this.state;
        const selectedCourses = remote_course.data;
        courses.forEach((item) => {
          item.isLocked = "N";
        });
        for (let i = 0; i < selectedCourses.length; i++) {
          let course = selectedCourses[i];
          let code = course.courseCode;
          courses.forEach((item) => {
            if (item.courseCode === code) {
              item.isLocked = "Y";
            }
          });
        }
        this.setState({ courses, selectedCourses });
        //console.log('courses', courses)
      }
    }
    //清除[證照]選定
    const { occupations } = this.state;
    occupations.forEach((item) => {
      if (item.gidTalentOccupation === gidTalentOccupation) {
        item.isLocked = "Y";
      } else {
        item.isLocked = "N";
      }
    });
    this.setState({ occupations });
    // 選定[職業]對應[證照]
    const remote_certificate =
      await req_single_cms_learnmap_talent_occupation_certificate(item, token);
    if (remote_certificate) {
      if (remote_certificate.total > 0) {
        const selectedCertificates = remote_certificate.data;
        const { certificates } = this.state;
        certificates.forEach((item) => {
          item.isLocked = "N";
        });
        for (let i = 0; i < selectedCertificates.length; i++) {
          let certificate = selectedCertificates[i];

          let code = certificate.gidTalentExamCertificate;
          //console.log("code", code);
          certificates.forEach((item) => {
            // console.log(
            //   "item.gidTalentExamCertificate",
            //   item.gidTalentExamCertificate
            // );
            if (item.gidTalentExamCertificate === code) {
              item.isLocked = "Y";
            }
          });
        }
        this.setState({ certificates, selectedCertificates });
        //console.log(certificates, selectedCertificates)
      }
    }
    this.setState({ occupation: jobName, detailsloading: false });
  };
  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      detailsloading,
      defaultKey,
      talents,
      certificates,
      courses,
      occupations,
    } = this.state;
    const tabPanes =
      talents.length > 0
        ? talents.map((row, idx) => (
            <TabPane tab={row.talentTwName} key={row.nidTalent}>
              <Alert
                key={idx}
                description={row.talentDescription}
                type="success"
                showIcon
              />
            </TabPane>
          ))
        : "";
    const htmlcourses =
      courses.length > 0
        ? courses.map((row, idx) => (
            <span
              key={idx}
              className={
                row.isLocked === "Y" ? "btn btn-danger" : "btn btn-default"
              }
              style={{ marginLeft: "3px", marginBottom: "3px", cursor: "text" }}
            >
              {row.courseTwName}
            </span>
          ))
        : "";
    const htmlItems =
      talents.length > 0 ? (
        <>
          <Tabs defaultActiveKey={defaultKey} onChange={this.tab_change}>
            {tabPanes}
          </Tabs>
          <Card>
            <Divider orientation="left" plain>
              <span style={{ color: "blue" }}>
              <i className="fa fa-address-card" style={{ marginRight: "4px" }}>
                  {" "}
                </i>{" "}
                適用證照 <Tag color="orange">可點選 <i className="fa fa-mouse-pointer"></i></Tag>
              </span>
            </Divider>
            {certificates.length > 0
              ? certificates.map((row, idx) => (
                  <>
                    <button
                      key={idx}
                      className={
                        row.isLocked === "Y"
                          ? "btn btn-primary"
                          : "btn btn-default"
                      }
                      style={{ marginLeft: "3px", marginBottom: "3px" }}
                      onClick={() => this.handle_certificate_click(row)}
                    >
                      {row.certificateTwName}
                    </button>
                  </>
                ))
              : ""}
          </Card>
          <Card>
            <Divider orientation="left" plain>
              <span style={{ color: "green" }}>
                <i className="fa fa-universal-access" style={{ marginRight: "4px" }}>
                  {" "}
                </i>{" "}
                適用職業 <Tag color="orange">可點選 <i className="fa fa-mouse-pointer"></i></Tag>
              </span>
            </Divider>
            {occupations.length > 0
              ? occupations.map((row, idx) => (
                  <button
                    key={idx}
                    className={
                      row.isLocked === "Y"
                        ? "btn btn-success"
                        : "btn btn-default"
                    }
                    style={{ marginLeft: "3px", marginBottom: "3px" }}
                    onClick={() => this.handle_occupation_click(row)}
                  >
                    {row.jobName}
                  </button>
                ))
              : ""}
          </Card>
          <Card>
            <Divider orientation="left" plain>
              <span style={{ color: "red" }}>
                <i className="fas fa-book" style={{ marginRight: "4px" }}>
                  {" "}
                </i>{" "}
                適用課程
              </span>
            </Divider>

            {htmlcourses}
          </Card>
          {detailsloading ? (
            <div className="text-center">
              <p />
              <button className="btn " type="button" disabled>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: "4px" }}
                ></span>
                Loading...
              </button>
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <Alert
          message="無相關資訊(此功能僅適用日四技查詢)"
          type="warning"
          closable
        />
      );

    return (
      <>
        {loading ? (
          <div className="text-center">
            <p />
            <button className="btn " type="button" disabled>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                style={{ marginRight: "4px" }}
              ></span>
              Loading...
            </button>
          </div>
        ) : (
          <>{htmlItems}</>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CoursemapStudentCourseLicensemap);
